// import ssc from './ssc';
// import xyrb from './xyrb';
import hpten from './hpten';
import ks from './ks';

export default (type, data, ballindex, Vue) => {
  if (type == 'hpten') {
    return hpten(data, ballindex);
  }
  // if (type == 'xyrb') {
  //   return xyrb(data);
  // }
  // if (type == 'PK10' || type == 'nn') {
  //   return pk10(data);
  // }
  if (type == 'ks') {
    return ks(data, ballindex);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Daxiaozhoushi/columns/index.js